import React, {useState} from 'react';
import Select from "react-select";
import {useSelector} from "react-redux";
import {bbFindUserTagsByTagId} from "../../../util/bbHelpers";
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";

const DefaultTableSizeSelect = ({customer=null,}) => {

    const authUser = useSelector(({auth}) => auth.authUser);
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);

    const isDisabled = true;
    const textColor = isDisabled && "text-light-gray";

    const tableSizeTags = bbFindUserTagsByTagId(authUser, 18);


    const options = [
        {value: '5', label: "5"},
        {value: '10', label: "10"},
        {value: '25', label: "25"},
        {value: '50', label: "50"},
        {value: '100', label: "100"},

    ]

    const [tableSize, setTableSize] = useState(tableSizeTags
        && tableSizeTags.length > 0
        && tableSizeTags[0]
        && tableSizeTags[0].definition
        && tableSizeTags[0].definition.description
            ? tableSizeTags[0].definition.description : options[0]);

    const handleOnClick = (value) =>{
        setTableSize(value)
    }


    return(

            <div className={`row ${textColor}`}>
                <Tooltip title={"Select default number of rows for large tables throughout application."}>
                    <>
                        <p className={"col-5 text-right align-self-center"}>Default Table Rows:</p>
                        <p className={"col-1"}> </p>
                        <p className={"col-5 text-left"}>
                            <Select
                                isDisabled={isDisabled}
                                className={"col-6 m-0 p-0"}
                                options={options}
                                value={tableSize}
                                onChange={handleOnClick}>
                            </Select>
                        </p>
                    </>
                </Tooltip>
                {isDisabled && <ComingSoonIconSettings/>}
            </div>
    )
}

export default DefaultTableSizeSelect;